export type BootcampDesign = 'control' | 'test';
type FeatureFlagValue = string | boolean | null | undefined;
export const normalizeBootcampDesign = (value: FeatureFlagValue): BootcampDesign | null =>
  value === 'control' || value === 'test' ? value : null;

type BootcampAssignmentInput = {
  previewValue: string | null;
  allowPreview: boolean;
  /** navigator.webdriver: a Playwright or other automated browser. */
  automatedBrowser?: boolean;
  variant: FeatureFlagValue;
  isLoading: boolean;
  isExperimentActive: boolean;
};
type BootcampAssignment = {
  design: BootcampDesign | null;
  preview: BootcampDesign | null;
  active: boolean;
};

/** Explicit local previews never become live assignments or enter old cohorts. */
export function resolveBootcampDesign(input: BootcampAssignmentInput): BootcampAssignment {
  const preview = input.allowPreview ? normalizeBootcampDesign(input.previewValue) : null;
  // On localhost and Dev, an automated browser that names no arm keeps the
  // pre-experiment page, so a live flag cannot bucket release tests at random.
  if (input.allowPreview && input.automatedBrowser && !preview) {
    return { design: null, preview: null, active: false };
  }
  const assigned = normalizeBootcampDesign(input.variant);
  const active = !input.isLoading && input.isExperimentActive && assigned !== null;
  return { design: preview || (active ? assigned : null), preview, active: active && !preview };
}
